<template>
    <div>
        <b-modal
            id="destroyTask"
            title="Deletar Atividade"
            hide-footer>
            <b-overlay :show="loading" rounded="sm">

                <p v-if="task">
                    Tem certeza que deseja deletar a atividade <b>{{ task.name }}</b> ?
                </p>

                <!-- Destroy -->
                <b-button type="button" variant="danger" :disable="loading" @click="destroy">
                    Deletar Atividade
                </b-button>

            </b-overlay>
        </b-modal>
    </div>
</template>

<script>
export default {
    data() {
        return {
            loading: false,
            task: null,
            id: null
        }
    },
    created() {

        this.$root.$on('destroyTask', (task) => {
            this.task = task;
            this.id = task.id;
            this.$bvModal.show('destroyTask')
        })

    },
    methods: {

        destroy() {
            this.loading = true;
            axios.delete('/teacher/tasks/' + this.id)
                .then((result) => {
                    // Redirect
                    this.redirectIfNeed(result)

                    // Clear Errors
                    this.errors = {}
                })
                .finally(() => this.loading = false)
        },
    }
}
</script>

<style scoped>

</style>
